const DISPLAY_MODES = {
    MOBILE: 'MOBILE',
    CINEMA: 'CINEMA',
    NORMAL: 'NORMAL'
}

export default DISPLAY_MODES;